/**
 * SGKC027A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ExtractionconditionInfoDto {

    /**
     * 会社コード
     */
    companycode?: string;
    /**
     * エネルギー種別コード
     */
    energyClscode?: string;
    /**
     * ＬＰ販売形態コード
     */
    lpSalesformcode?: string;
    /**
     * 承認単価権限管理ID
     */
    apprvTankaauthorityManagementid?: string;
}

